import { useCallback, useState } from 'react';

/** Copy text to the clipboard and briefly expose a `copied` flag for UI feedback. */
export function useClipboard(resetMs = 1500): { copied: boolean; copy: (text: string) => Promise<void> } {
  const [copied, setCopied] = useState(false);
  const copy = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), resetMs);
    } catch {
      setCopied(false);
    }
  }, [resetMs]);
  return { copied, copy };
}
